import { lazy } from 'react'

export const ActivateInstanceModalAsync = lazy(() => import('./ActivateInstanceModal')
    .then((module) => ({ default: module.ActivateInstanceModal }))
)
